import { samplePlanStatusArr, samplePlanTypeArr, samplePropertyArr, sampleResponseArr } from "./sample_response";
import User from '../models/User'
import Http from './Http'
import React, { useState } from "react";
import { useHMG } from "../HMGContext";
import helper from "./helper";

class DataService extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            selectedHMGId: null,
        };
    }

    planTypeOptions;
    planStatusOptions;
    allProperties = null;
    propertiesArr = null;
    hmgArr = null;
    user = null;
    allDepartments = null;
    allDrivers = null;
    allAccountTypes = null;
    allStructureCodes = null;
    // Per-cache org/hmg keys + in-flight promises. Each reference cache tracks its OWN key so
    // changing org invalidates each cache independently (a shared key caused stale cross-talk),
    // and shares a single request across concurrent callers (in-flight dedup).
    allDepartmentsOrgId = null;
    allDepartmentsInflight = null;
    allAccountTypesOrgId = null;
    allAccountTypesInflight = null;
    allStructureCodesHmgId = null;
    allStructureCodesInflight = null;
    allDriversInflight = null;
    departmentMappingsByOrg = new Map();
    departmentMappingsInflight = new Map();
    // HMG users + closed-month account data: Map keyed by hmgId + in-flight promise (same
    // cache + de-dup pattern as departmentMappingsByOrg) so the many independent callers on
    // Plan Details load share a single request instead of each firing its own (TPX-1856).
    hmgUsersByHmg = new Map();
    hmgUsersInflight = new Map();
    closedMonthByHmg = new Map();
    closedMonthInflight = new Map();
    // Property-level resolved closed-month: Map keyed by `${orgId}:${propertyId}` + in-flight promise
    // (same cache + de-dup pattern as closedMonthByHmg) so the header and PlanDetailsView share a
    // single request on Plan Details load instead of each firing its own resolved call (TPX-1856).
    resolvedClosedMonthByKey = new Map();
    resolvedClosedMonthInflight = new Map();

    getUser(){
        return this.user;
    }

    isDemoUser() {
        const demoUsers = [
            "trueplandemo1@otelier.io",
            "Trueplandemo2@otelier.io",
            "Trueplandemo3@otelier.io"
        ];
    
        return demoUsers.some(
            email => helper.matchStringNotCaseSensitive(email, this.getUserEmail())
        );
    }    
    
    getUserEmail(){
        return this.user.email;
    }

    getSelectedHMGId(){
        return this.state.selectedHMGId;
    }

    setSelectedHMGId(id){
        if(id!=null && id!=undefined && String(id)!=''){
            const prev = this.state.selectedHMGId;
            this.state.selectedHMGId = id;
            localStorage.setItem('selectedHmgId', id); // Save to sessionStorage
            if (prev != null && String(prev) !== String(id)) {
                this.invalidateDepartmentMappingsCache();
                this.invalidateHmgScopedCaches();
            }
        }
    }

    setPropertiesArr(hmgPropArr){
        if(hmgPropArr!=null && hmgPropArr!=undefined){
            this.propertiesArr = [];
            this.propertiesArr = hmgPropArr;
            // this.propertiesArr.push(...samplePropertyArr);
        }
    }

    setHmgArr(hmgArr){
        if(hmgArr!=null && hmgArr!=undefined){
            this.hmgArr = hmgArr;
        }
    }

    setAllProperties(hmgList){
        if(!helper.isNull(hmgList) && hmgList.length > 0)
        this.allProperties = hmgList.flatMap(m=>m.properties);
    }

    getPropertyStartMonth(propId){
        var period = this.allProperties.find(f=>f.id == propId)?.calendarType        
        return period?.split("-")[0] 
    }

    getPropertyEndMonth(propId){
        var period = this.allProperties.find(f=>f.id == propId).calendarType        
        return period.split("-")[1] 
    }

    async fetchUserMeta(userEmail) {
        if (!this.user) {

            return new Promise((resolve, reject) => {
                Http.GET("user?userEmail="+userEmail)
                    .then(res => {
                        if (res && res?.status === 200) {
                            this.user = new User(res.data);
                            this.setHmgArr(this.user.hmg);
                            this.setAllProperties(this.user.hmg);

                            if(res.data.hasAssumedUser){
                                sessionStorage.setItem('showViewAsUser', res.data.hasAssumedUser);
                                sessionStorage.setItem('selectedUser', res.data.assumedUserFullName);
                                if (res.data.assumedUserId != null) {
                                    sessionStorage.setItem('assumedUserId', String(res.data.assumedUserId));
                                }
                            }else{
                                sessionStorage.removeItem('showViewAsUser');
                                sessionStorage.removeItem('selectedUser');
                                sessionStorage.removeItem('assumedUserId');
                            }

                            if(this.user.hmg != null && this.user.hmg.length > 0){
                                // Use saved HMG ID from sessionStorage if available, otherwise default to first HMG
                                const savedHmgId = localStorage.getItem('selectedHmgId');
                                const selectedHmg = savedHmgId 
                                    ? this.user.hmg.find(hmg => String(hmg.id) === String(savedHmgId)) || this.user.hmg[0]
                                    : this.user.hmg[0];
                                useHMG.setSelectedHMG = selectedHmg;
                                this.setSelectedHMGId(selectedHmg.id);
                                this.setPropertiesArr(selectedHmg.properties);
                            }
                            resolve(this.user); // Resolve with the user data
                        } else if (res && res?.status === 204) {
                            // Handle 204 case
                            resolve(null); // Resolves with null if no user data is found
                        } else {
                            // Handle other non-200 statuses
                            reject(new Error('User fetch failed with status: ' + res?.status));
                        }
                    })
                    .catch(error => {
                        // Handle network or other errors
                        reject(error); // Reject the promise if there's an error
                    });
            });
        } 

        // If user data is already set, return a resolved promise immediately
        return Promise.resolve(this.user);
    }

    
    getFullUserName(){
        if(!this.user)
            return "Error"
        return this.user.firstname + " " + this.user.lastname
    }

    getSelectedHMG(hmgId=null){
        if(hmgId==null || hmgId==undefined){
            hmgId = this.state.selectedHMGId;
        }
        return this.getUser().hmg.find(f=>f.id==hmgId);
    }

    getPropertiesListForHMG(hmgId=null) {

        if(hmgId==null || hmgId==undefined){
            hmgId = this.state.selectedHMGId;
        }

        let selectedHMGData = this.getUser().hmg.find(f=>f.id==hmgId);
        this.setPropertiesArr(selectedHMGData.properties);
        
        return selectedHMGData.properties.sort((a, b) => a.name.localeCompare(b.name));
    }

    getPropertiesForHMG(isSelectAll = false, hmgId=null) {

        if(hmgId==null || hmgId==undefined){
            hmgId = this.state.selectedHMGId;
        }

        let selectedHMGData = this.getUser().hmg.find(f=>f.id==hmgId);

        this.setPropertiesArr(selectedHMGData.properties);
        
        // console.log(this.propertiesArr);
        const propertyList = this.propertiesArr.map(property => ({
            value: property.id,
            label: property.name || ''  // Fallback to empty string if name is undefined or null
        })).sort((a, b) => {
            // Handle undefined or null names safely during sorting
            const labelA = a.label || ''; // Default to empty string if label is undefined or null
            const labelB = b.label || ''; // Default to empty string if label is undefined or null
            return labelA.localeCompare(labelB);
        });

        if(isSelectAll) {
            // Add the "Select all" option at the top
            propertyList.unshift({
                label: 'Select all',
                value: 'all',
                dateFormat: 'MMM d, yyyy'
            });
        }
    
        return propertyList;
    }

    async getAllDepartmentData() {
  const currentOrganizationId = this.getSelectedHMGId();

  // Invalidate cache if organization changed (own key — not shared across caches).
  if (this.allDepartmentsOrgId !== null && this.allDepartmentsOrgId !== currentOrganizationId) {
    this.allDepartments = null;
  }

  if (this.allDepartments) {
    return this.allDepartments;
  }

  // In-flight dedup: concurrent callers share a single network request.
  if (this.allDepartmentsInflight) {
    return this.allDepartmentsInflight;
  }

  this.allDepartmentsInflight = (async () => {
    try {
      const res = await Http.GET("plan-details/get-all-departments?organizationId="+currentOrganizationId);
      if (res && res.status === 200) {
        this.allDepartments = res.data;
        this.allDepartmentsOrgId = currentOrganizationId;
      }
      // non-200: leave cache empty so a later call retries (M-03: don't poison the cache with []).
    } catch (error) {
      console.error("Error fetching departments:", error);
      if (error.response?.status === 503) {
        console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
      }
      // Don't cache the failure — leave cache empty so a later call retries (M-03).
    } finally {
      this.allDepartmentsInflight = null;
    }
    return this.allDepartments || [];
  })();

  return this.allDepartmentsInflight;
}

  async getDepartmentMappingsByOrganisation(organisationId) {
    if (organisationId == null || organisationId === "") {
      return [];
    }
    const key = String(organisationId);
    if (this.departmentMappingsByOrg.has(key)) {
      return this.departmentMappingsByOrg.get(key);
    }
    if (this.departmentMappingsInflight.has(key)) {
      return this.departmentMappingsInflight.get(key);
    }
    const pending = (async () => {
      try {
        const res = await Http.GET(
          "department-mappings?organisationId=" + encodeURIComponent(organisationId)
        );
        let rows = [];
        if (res && res.status === 200 && Array.isArray(res.data)) {
          rows = res.data;
        }
        this.departmentMappingsByOrg.set(key, rows);
        return rows;
      } catch (error) {
        console.error("Error fetching department mappings:", error);
        return [];
      } finally {
        this.departmentMappingsInflight.delete(key);
      }
    })();
    this.departmentMappingsInflight.set(key, pending);
    return pending;
  }

  invalidateDepartmentMappingsCache(organisationId) {
    if (organisationId == null || organisationId === "") {
      this.departmentMappingsByOrg.clear();
      this.departmentMappingsInflight.clear();
      return;
    }
    const key = String(organisationId);
    this.departmentMappingsByOrg.delete(key);
    this.departmentMappingsInflight.delete(key);
  }

  // Cached + de-duped HMG users list. Returns an array (empty on failure — not cached, so a later
  // call retries). Concurrent callers share one in-flight request, which also collapses React
  // StrictMode's dev double-invoke.
  async getHmgUsersFiltered(hmgId) {
    if (hmgId == null || hmgId === "") return [];
    const key = String(hmgId);
    if (this.hmgUsersByHmg.has(key)) return this.hmgUsersByHmg.get(key);
    if (this.hmgUsersInflight.has(key)) return this.hmgUsersInflight.get(key);
    const pending = (async () => {
      try {
        const res = await Http.GET("user/hmg-users-filtered?hmgId=" + encodeURIComponent(hmgId));
        if (res && res.status === 200 && Array.isArray(res.data)) {
          this.hmgUsersByHmg.set(key, res.data);
          return res.data;
        }
        return [];
      } catch (error) {
        console.error("Error fetching hmg users:", error);
        return [];
      } finally {
        this.hmgUsersInflight.delete(key);
      }
    })();
    this.hmgUsersInflight.set(key, pending);
    return pending;
  }

  // Cached + de-duped org-level closed-month account data. Returns the data object (or null on
  // failure — not cached). Concurrent callers share one in-flight request.
  async getClosedMonthAccountData(hmgId) {
    if (hmgId == null || hmgId === "") return null;
    const key = String(hmgId);
    if (this.closedMonthByHmg.has(key)) return this.closedMonthByHmg.get(key);
    if (this.closedMonthInflight.has(key)) return this.closedMonthInflight.get(key);
    const pending = (async () => {
      try {
        const res = await Http.GET("organisation-closed-month-account-data/get-data/" + encodeURIComponent(hmgId));
        if (res && res.status === 200 && res.data != null) {
          this.closedMonthByHmg.set(key, res.data);
          return res.data;
        }
        return null;
      } catch (error) {
        console.error("Error fetching closed-month account data:", error);
        return null;
      } finally {
        this.closedMonthInflight.delete(key);
      }
    })();
    this.closedMonthInflight.set(key, pending);
    return pending;
  }

  // Cached + de-duped property-level resolved closed-month data. Returns the data object (or null on
  // failure — not cached). Concurrent callers (header + PlanDetailsView) share one in-flight request.
  async getResolvedClosedMonth(orgId, propertyId) {
    if (orgId == null || orgId === "" || propertyId == null || propertyId === "") return null;
    const key = String(orgId) + ":" + String(propertyId);
    if (this.resolvedClosedMonthByKey.has(key)) return this.resolvedClosedMonthByKey.get(key);
    if (this.resolvedClosedMonthInflight.has(key)) return this.resolvedClosedMonthInflight.get(key);
    const pending = (async () => {
      try {
        const res = await Http.GET("organisation-closed-month-account-data/resolved/" + encodeURIComponent(orgId) + "/" + encodeURIComponent(propertyId));
        if (res && res.status === 200 && res.data != null) {
          this.resolvedClosedMonthByKey.set(key, res.data);
          return res.data;
        }
        return null;
      } catch (error) {
        console.error("Error fetching resolved closed-month account data:", error);
        return null;
      } finally {
        this.resolvedClosedMonthInflight.delete(key);
      }
    })();
    this.resolvedClosedMonthInflight.set(key, pending);
    return pending;
  }

  // Clear the hmg-users and closed-month caches (call on org change so a switch refetches fresh).
  invalidateHmgScopedCaches() {
    this.hmgUsersByHmg.clear();
    this.hmgUsersInflight.clear();
    this.closedMonthByHmg.clear();
    this.closedMonthInflight.clear();
    this.resolvedClosedMonthByKey.clear();
    this.resolvedClosedMonthInflight.clear();
  }

  // Clear only the closed-month caches (org + resolved). Call after saving org-level
  // closed-month settings (e.g. "Show Committed changes") so pages that read them refetch
  // fresh on their next mount instead of showing a stale value until a hard reload (TPX-2048).
  invalidateClosedMonthCaches() {
    this.closedMonthByHmg.clear();
    this.closedMonthInflight.clear();
    this.resolvedClosedMonthByKey.clear();
    this.resolvedClosedMonthInflight.clear();
  }

async getAllAccountTypesData() {
  const currentOrganizationId = this.getSelectedHMGId();

  // Invalidate cache if organization changed (own key — not shared across caches).
  if (this.allAccountTypesOrgId !== null && this.allAccountTypesOrgId !== currentOrganizationId) {
    this.allAccountTypes = null;
  }

  if (this.allAccountTypes) {
    return this.allAccountTypes;
  }

  // In-flight dedup: concurrent callers share a single network request.
  if (this.allAccountTypesInflight) {
    return this.allAccountTypesInflight;
  }

  this.allAccountTypesInflight = (async () => {
    try {
      const res = await Http.GET("account-type/get-all-account-types?organizationId="+currentOrganizationId);
      if (res && res.status === 200) {
        this.allAccountTypes = res.data;
        this.allAccountTypesOrgId = currentOrganizationId;
      }
      // non-200: leave cache empty so a later call retries (M-03).
    } catch (error) {
      console.error("Error fetching account types:", error);
      if (error.response?.status === 503) {
        console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
      }
      // Don't cache the failure — leave cache empty so a later call retries (M-03).
    } finally {
      this.allAccountTypesInflight = null;
    }
    return this.allAccountTypes || [];
  })();

  return this.allAccountTypesInflight;
}

async getAllDriverData() {
  if (this.allDrivers) {
    return this.allDrivers;
  }

  // In-flight dedup: concurrent callers share a single network request.
  if (this.allDriversInflight) {
    return this.allDriversInflight;
  }

  this.allDriversInflight = (async () => {
    try {
      const res = await Http.GET("driver/options");
      if (res && res.status === 200) {
        this.allDrivers = res.data;
      }
      // non-200: leave cache empty so a later call retries (M-03).
    } catch (error) {
      console.error("Error fetching drivers:", error);
      if (error.response?.status === 503) {
        console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
      }
      // Don't cache the failure — leave cache empty so a later call retries (M-03).
    } finally {
      this.allDriversInflight = null;
    }
    return this.allDrivers || [];
  })();

  return this.allDriversInflight;
}

async getAllStructureCodeData() {
  const currentHmgId = localStorage.getItem('selectedHmgId') || this.getSelectedHMGId();

  // Invalidate cache if HMG changed (own key — not shared across caches).
  if (this.allStructureCodesHmgId !== null && this.allStructureCodesHmgId !== currentHmgId) {
    this.allStructureCodes = null;
  }

  if (this.allStructureCodes) {
    return this.allStructureCodes;
  }

  // In-flight dedup: concurrent callers share a single network request.
  if (this.allStructureCodesInflight) {
    return this.allStructureCodesInflight;
  }

  this.allStructureCodesInflight = (async () => {
    try {
      const res = await Http.GET("chart-of-accounts/all-structure-code-leaf?hmgId="+currentHmgId);
      if (res && res.status === 200) {
        this.allStructureCodes = res.data;
        this.allStructureCodesHmgId = currentHmgId;
      }
      // non-200: leave cache empty so a later call retries (M-03).
    } catch (error) {
      console.error("Error fetching structure codes:", error);
      if (error.response?.status === 503) {
        console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
      }
      // Don't cache the failure — leave cache empty so a later call retries (M-03).
    } finally {
      this.allStructureCodesInflight = null;
    }
    return this.allStructureCodes || [];
  })();

  return this.allStructureCodesInflight;
}



    getHMGList(){
    //   const hmgList = this.getUser().hmg.sort((a, b) => a.name.localeCompare(b.name)) // Sort in ascending order by label 
      return this.hmgArr || [];
    }
    
    getPlanYearOptions() {
        const currentYear = new Date().getFullYear(); // Get the current year
        const years = [];

        // Add the current year and the past 3 years
        for (let i = currentYear - 3; i <= currentYear + 3; i++) {
            years.push({ value: `${i}`, label: `${i}` });
        }

        return years;
    }
    getPlanTypeOptions(){
        return samplePlanTypeArr.map(planType =>  ({
            value: planType.name,
            label: planType.name
            })
        ); // Extract propert
    }

    getPlanType(planTypeId){
        let label = ''
        samplePlanTypeArr.forEach(f=>{if(f.id === planTypeId){label=f.name;return;}});
        // return samplePlanTypeArr.find(m=>{if(m.id === planTypeId)return m.name;});
        return label
    }

    async getPlanStatusOptions(){

        if(this.planStatusOptions)return this.planStatusOptions;

        try {
          let resp = await Http.GET("plan/planstatus")

          this.planStatusOptions = resp.data;
          
          return this.planStatusOptions;
        } catch (error) {
          console.error("Error fetching plan status options:", error);
          if (error.response?.status === 503) {
            console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
          }
          return [];
        }
    }

    getPlanStatus(planStatusId) {
        
        // if(this.planStatusOptions)return this.planStatusOptions.find(m =>{ if(m.id === planStatusId)return m.name});

        // const status = this.getPlanStatusOptions().then(data=>{return data.find(m => m.planStatusId === planStatusId)});

        let status = samplePlanStatusArr.find(m => m.id === planStatusId);
        
        return status ? status.name : 'Unknown Status'; 
    }

    async getPlans(){
        try {
          return await Http.GET('plan/filter');
        } catch (error) {
          console.error("Error fetching plans:", error);
          if (error.response?.status === 503) {
            console.log("http logger - 503 error:", error.response.data?.message || 'Service unavailable');
          }
          throw error; // Re-throw so calling code can handle
        }
    }

    getPropertyById(propertyId){
        if (Array.isArray(propertyId)) {
            propertyId = propertyId[0]; // Use the first element if it is an array
        }
        return this.allProperties.find(f=>{if(propertyId===f.id)return f});
    }
    getPropertyByIds(propertyIds){
        if (Array.isArray(propertyIds)) {
            propertyIds = propertyIds[0]; // Use the first element if it is an array
        }
        return this.allProperties.find(f=>{if(propertyIds===f.id)return f});
    }

    getAllHMGPropertyIds() {
        return this.propertiesArr.map(property => property.id);
    }

    getOrganisationByPropertyId(propertyId) {
        // Iterate over the "hmg" array
        for (const organisation of this.user.hmg) {
          // Check the properties array within each organisation
          for (const property of organisation.properties) {
            if (property.id === propertyId) {
              return organisation.id; // Return organisationId if propertyId matches
            }
          }
        }
        // Return null if no matching propertyId is found
        return null;
    }

    getUserId(){
        if(this.user === null)
            return null;

        return this.user.id;
    }
}

const dataService = new DataService();

export default dataService;